import { render, staticRenderFns } from "./ElectronicDocumentsSuccess.vue?vue&type=template&id=464a22b4&scoped=true"
import script from "./ElectronicDocumentsSuccess.vue?vue&type=script&lang=js"
export * from "./ElectronicDocumentsSuccess.vue?vue&type=script&lang=js"
import style0 from "./ElectronicDocumentsSuccess.vue?vue&type=style&index=0&id=464a22b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464a22b4",
  null
  
)

export default component.exports